export enum ShoppingCartQuantities {
  Min = 25,
  Max = 500,
  Increment = 1,
}
